import { combineReducers } from 'redux';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Actions, StoreState } from '../types';

interface JitsiCall {
  id: string
  result: JitsiResult
}

export enum JitsiResult {
  None = 0,
  Sent = 1,
  Accept = 2,
  Decline = 3
}

export function jitsi(state: JitsiCall = { id: '', result: JitsiResult.None }, action: Actions): JitsiCall {
  if (action.type === getType(actions.requestJitsiStart)) {
    return { id: action.payload.id, result: JitsiResult.Sent }
  } else if (action.type === getType(actions.updateJitsiStatus)) {
    return { id: action.payload.id, result: action.payload.response }
  } else if (action.type === getType(actions.requestJitsiClear)) {
    return { id: '', result: JitsiResult.None }
  }
  return state
}

export function getRoot(state: StoreState) {
  return state.settings
}

export function getJitsi(state: StoreState) {
  return getRoot(state).jitsi
}

interface AudioPlaying {
  file: string
  current: number
}

export function playing(state: AudioPlaying = { file: '', current: 0 }, action: Actions): AudioPlaying {
  if (action.type === getType(actions.requestAudioPlaying)) {
    return { file: action.payload.file, current: action.payload.current }
  } 

  return state
}

export function closing(state: boolean = false, action: Actions) {
  if (action.type === getType(actions.shutdown)) {
    return true
  } 

  return state
}

export function getAudioPlaying(state: StoreState) {
  return getRoot(state).playing
}

export function shuttingDown(state: StoreState) {
  return getRoot(state).closing
}

export default combineReducers({
  jitsi,
  playing,
  closing,
})
